import React from 'react';
import { Button, Heading } from 'bumbag';

import LandingPage from '@medipass/react-core/Layout/LandingPage';
import { Link as RouterLink } from '@medipass/react-core/router';
export default function NotFound() {
  return (
    <LandingPage title="We lost you!">
      <Heading use="h1" paddingBottom="major-2">
        Page not found
      </Heading>
      {/* @ts-expect-error TS(2322): Type '{ children: string; variant: string; palette... Remove this comment to see the full error message */}
      <Button variant="outlined" palette="secondary" use={RouterLink} to="/">
        Go home
      </Button>
    </LandingPage>
  );
}
